import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useRideStatus } from '../context/RideStatusContext';
import PageLabel from './PageLabel';
import OrderForm from './OrderForm';
import Loader from './Loader';
import backendApi from '../services/backendApi';
import {useAuth} from "../context/AuthContext";

function RepeatOrder() {
    const [loading, setLoading] = useState(false);
    const [defaultValues, setDefaultValues] = useState(null);
    const [defaultCategory, setDefaultCategory] = useState(null);
    const [formKey, setFormKey] = useState(0);
    const { login } = useAuth();
    const { encodedId } = useParams();

    const navigate = useNavigate();
    const { rideInSearch, setRideInSearch } = useRideStatus();

    useEffect(() => {
        const fetchLastOrder = async () => {
            setLoading(true);

            try {
                const response = await backendApi.request({
                    url: '/api/recreate-order',
                    method: 'POST',
                    data: { orderId: encodedId },
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                const values = {
                    addressFrom: response.data.addressFrom,
                    addressTo: response.data.addressTo,
                };

                setDefaultValues(values);
                setDefaultCategory(response.data.category);
                setFormKey((prev) => prev + 1);

                const clientProfileResponse = await backendApi.get('/api/get-user-profile');

                if (clientProfileResponse.status == 200) {
                    const userData = clientProfileResponse.data;

                    if (userData && userData.client) {
                        login(userData.client);
                    }
                }
            } catch (e) {
                console.error('Nepavyko gauti ankstesnio užsakymo', e);
            } finally {
                setLoading(false);
            }
        };

        fetchLastOrder();
    }, []);

    useEffect(() => {
        if (rideInSearch) {
            navigate('/order');
        }
    }, [rideInSearch, navigate]);

    if (loading) return <Loader />;

    return (
        <div className="repeat-order pageContent">
            <PageLabel text="Pakartoti užsakymą" />
            <OrderForm
                key={formKey}
                defaultValues={defaultValues}
                defaultCategory={defaultCategory}
                setRideInSearch={setRideInSearch}
            />
        </div>
    );
}

export default RepeatOrder;